import * as actions from './actions';
import { initialState } from './reducer';
import * as selectors from './selectors';
import types, { moduleName } from './types';

export { actions as default, initialState as INIT_STATE, moduleName as NAME, selectors, types };
